import React, { useEffect, useState, useContext } from 'react'
import Graph from "./Graph";
import { apiEndPoint } from '../../../environment'
import { SelectSiteContext } from '../../context/SelectSite';
import { Link } from 'react-router-dom';
import moment from 'moment';

export default function Overview() {
    const { selectedSite } = useContext(SelectSiteContext);
    const [activityUser, setactivityUser] = useState([])
    const [currMonthDate, setCurrMonthDate] = useState([])
    const [activateY, setActivateY] = useState([])
    const [deActivateY, setDeActivateY] = useState([])

    function activity() {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        fetch(`${apiEndPoint}token/graph?siteUrl=${selectedSite.siteUrl}`, requestOptions)
            .then(response => response.json())
            .then(result => setactivityUser(result))
            .catch(error => console.log(error))
    }

    useEffect(() => {
        activity()
    }, [])

    useEffect(() => {
        const setFullDate = []
        const counterYActivate = []
        const counterYDeActivate = []
        const startDate = moment(activityUser.currMonth?.startDate).format("D")
        const endDate = moment(activityUser.currMonth?.endDate).format("DD")

        const currmonth = moment(activityUser.currMonth?.endDate).format("MM")
        const currYear = moment(activityUser.currMonth?.endDate).format("YYYY")

        const activeArray = activityUser.active
        const deActiveArray = activityUser.deactive

        if (activeArray && deActiveArray) {
            for (let i = startDate; i <= endDate; i++) {
                const setDate = moment(`${currYear}-${currmonth}-${i}`).format("YYYY-MM-DD")
                setFullDate.push(setDate)

                if (setDate in activeArray) {
                    counterYActivate.push(activeArray[setDate])
                } else {
                    counterYActivate.push(0)
                }

                if (setDate in deActiveArray) {
                    counterYDeActivate.push(deActiveArray[setDate])
                } else {
                    counterYDeActivate.push(0)
                }
            }

            setActivateY(counterYActivate)
            setDeActivateY(counterYDeActivate)
            setCurrMonthDate(setFullDate)
        }

    }, [activityUser.currMonth])


    const GraphConfig = {
        title: {
            text: "Daily User Activity",
        },
        yAxis: {
            title: {
                text: 'User',
            },
            categories: [],
        },
        xAxis: {
            title: {
                text: 'Date',
            },
            categories: currMonthDate,
        },
        accessibility: {
            enabled: false
        },
        series: [
            {
                type: "line",
                data: activateY,
                name: "Activate",
            },
            {
                type: "line",
                data: deActivateY,
                name: "deActivate",
            },
        ],
    };

    function kFormatter(num) {
        return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
    }

    return (
        <>
            <style
                dangerouslySetInnerHTML={{
                    __html:
                        "\n.line-chart-loader{\n    color: #2c7be5;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}  \n",
                }}
            />
            {/* <div className="card bg-light mb-3">
                <div className="card-body p-3">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-6 col-sm-8 d-flex align-items-center">
                            <h6>
                                Uptime{" "}
                                <span
                                    className="help-tooltip"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    title="We offer a basic Uptime Monitoring service to all of our customers for completely free. It checks your website for availability at 5-minute intervals from different locations around the world. It allows you to view uptime, downtime and the response time for all of your websites that use Webpushr."
                                >
                                    <i className="fa fa-question-circle" />
                                </span>
                            </h6>
                        </div>
                        <div className="col-auto">
                            <a
                                href="/uptime-monitoring"
                                className="btn btn-sm btn-falcon-primary btn-info"
                                type="button"
                                data-index={0}
                                data-toggle="tooltip"
                                data-placement="top"

                                data-original-title="Uptime Information"
                            >
                                <span className="fas fa-info" />
                            </a>
                        </div>
                    </div>
                    <div className="response-time mt-2">
                        <div className="page-loader text-center  ">
                            <div
                                className="spinner-border text-primary fs-0"
                                role="status"
                            >
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div className="response-graph-footer">
                        <div style={{ flexGrow: 0 }}>90 days ago</div>
                        <hr style={{ flexGrow: 1 }} />
                        <div style={{ flexGrow: 0 }} id="overall-uptime" />
                        <hr style={{ flexGrow: 1 }} />
                        <div style={{ flexGrow: 0 }}>Today</div>
                    </div>
                </div>
            </div> */}
            <div
                className="row"
                style={{ marginLeft: "-7px", marginRight: "-7px" }}
            >
                {/* IMPRESSIONS */}
                <div className="col-lg-4 pl-lg-2 pr-lg-2 mb-3">
                    <div className="card ">
                        <div className="card-header pb-0">
                            <div className="row" style={{ flexDirection: "column" }}>
                                <h6 className="mb-0 col-auto">
                                    Impressions{" "}
                                    <span
                                        className="help-tooltip"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        data-html="true"
                                        title="The number of times a push notification or in-browser notification was displayed to the user."
                                    >
                                        <i className="fa fa-question-circle" />
                                    </span>
                                </h6>
                                <span
                                    style={{
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        color: "#b1b1b1",
                                        paddingLeft: "15px",
                                    }}
                                >
                                    {/* This month (Jan 01 - Jan 12) */}
                                </span>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "right",
                                    gap: "5px",
                                }}
                            >
                                <span
                                    style={{
                                        color: "#333",
                                        fontWeight: 800,
                                        fontSize: "20px",
                                    }}
                                    id="impression-total"
                                />
                                <span
                                    className="badge badge-pill "
                                    id="impression-percent"
                                />
                            </div>
                        </div>
                        <div className="card-body ">
                            <div
                                className="line-chart-loader"
                                style={{ color: "#2c7be5" }}
                            >
                                {/* <div className="page-loader text-center  ">
                                    <div
                                        className="spinner-border text-primary fs-0"
                                        role="status"
                                    >
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div> */}

                                <div className='font-weight-bold h1'>{kFormatter(selectedSite.impressions)}</div>
                            </div>
                            <canvas id="chart-impression" height="100px" />
                        </div>
                    </div>
                </div>
                {/* INTERACTIONS */}
                <div className="col-lg-4 pl-lg-2 pr-lg-2 mb-3">
                    <div className="card ">
                        <div className="card-header pb-0">
                            <div className="row" style={{ flexDirection: "column" }}>
                                <h6 className="mb-0 col-auto">
                                    Interactions{" "}
                                    <span
                                        className="help-tooltip"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        data-html="true"
                                        title="The number of times a push notification or in-browser notification was clicked or closed."
                                    >
                                        <i className="fa fa-question-circle" />
                                    </span>
                                </h6>
                                <span
                                    style={{
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        color: "#b1b1b1",
                                        paddingLeft: "15px",
                                    }}
                                >
                                    {/* This month (Jan 01 - Jan 12) */}
                                </span>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "right",
                                    gap: "5px",
                                }}
                            >
                                <span
                                    style={{
                                        color: "#333",
                                        fontWeight: 800,
                                        fontSize: "20px",
                                    }}
                                    id="interactions-total"
                                />
                                <span
                                    className="badge badge-pill"
                                    id="interactions-percent"
                                />
                            </div>
                        </div>
                        <div className="card-body " >
                            <div
                                className="line-chart-loader"
                                style={{ color: "#2c7be5" }}
                            >
                                {/* <div className="page-loader text-center  ">
                                    <div
                                        className="spinner-border text-primary fs-0"
                                        role="status"
                                    >
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div> */}
                                <div className='font-weight-bold h1'>{kFormatter(selectedSite.interactions)}</div>
                            </div>
                            <canvas id="chart-interactions" height="100px" />
                        </div>
                    </div>
                </div>
                {/* CTR */}
                <div className="col-lg-4 pl-lg-2 pr-lg-2 mb-3">
                    <div className="card ">
                        <div className="card-header pb-0">
                            <div className="row" style={{ flexDirection: "column" }}>
                                <h6 className="mb-0 col-auto">
                                    CTR{" "}
                                    <span
                                        className="help-tooltip"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        data-html="true"
                                        title="Interactions divided by Impressions"
                                    >
                                        <i className="fa fa-question-circle" />
                                    </span>
                                </h6>
                                <span
                                    style={{
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        color: "#b1b1b1",
                                        paddingLeft: "15px",
                                    }}
                                >
                                    {/* This month (Jan 01 - Jan 12) */}
                                </span>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "right",
                                    gap: "5px",
                                }}
                            >
                                <span
                                    style={{
                                        color: "#333",
                                        fontWeight: 800,
                                        fontSize: "20px",
                                    }}
                                    id="ctr-percent"
                                />
                                <span className="badge badge-pill" id="ctr-" />
                            </div>
                        </div>
                        <div className="card-body ">
                            <div
                                className="line-chart-loader"
                                style={{ color: "#2c7be5" }}
                            >
                                {/* <div className="page-loader text-center  ">
                                    <div
                                        className="spinner-border text-primary fs-0"
                                        role="status"
                                    >
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div> */}
                                <div className='font-weight-bold h1'>{kFormatter(((selectedSite.interactions / selectedSite.impressions) * 100).toFixed(2))}%</div>
                            </div>
                            <canvas id="chart-ctr" height="100px" />
                        </div>
                    </div>
                </div>
            </div>

            {/* chart  */}

            <div className="App">
                <Graph chartOptions={GraphConfig} />
            </div>


            <div className="card bg-light mb-3">
                <div className="card-body p-3">
                    <p className="fs--0 mb-0">
                        You are currently subscribed to the Free plan that has a
                        10,000 user limit.{" "}
                        <Link to="/account/plans">Upgrade</Link>{" "}
                        subscription now.
                    </p>
                </div>
            </div>
            {/* <div className="card-deck">
                <div
                    className="card mb-3 overflow-hidden"
                    style={{ minWidth: "12rem" }}
                >
                    <div
                        className="bg-holder bg-card"
                        style={{
                            backgroundImage:
                                "url(assets/img/illustrations/corner-3.png)",
                        }}
                    ></div>
                  
                    <div className="card-body position-relative">
                        <h6>
                            Active Users{" "}
                            <span
                                className="help-tooltip"
                                data-toggle="tooltip"
                                data-placement="top"
                                data-html="true"
                                title="Number of users that can receive your notifications. You might notice this number will decrease after you send a notification. This is because sending a notification helps us determine if a user is still active or not."
                            >
                                <i className="fa fa-question-circle" />
                            </span>{" "}
                            <a
                                className="font-weight-semi-bold fs--1 text-nowrap"
                                href="https://app.webpushr.com/sites/optimize_subscriber_count"
                            >
                                Optimize
                                <span
                                    className="fas fa-angle-right ml-1"
                                    data-fa-transform="down-1"
                                />
                            </a>
                        </h6>
                        <div className="display-4 fs-4 mb-2 font-weight-normal text-sans-serif active-subscribers">
                            <div className="page-loader text-center  ">
                                <div
                                    className="spinner-border text-primary fs-0"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                        <a
                            className="font-weight-semi-bold fs--1 text-nowrap"
                            href="https://app.webpushr.com/subscribers"
                        >
                            See all
                            <span
                                className="fas fa-angle-right ml-1"
                                data-fa-transform="down-1"
                            />
                        </a>
                    </div>
                </div>
                <div
                    className="card mb-3 overflow-hidden"
                    style={{ minWidth: "12rem" }}
                >
                    <div
                        className="bg-holder bg-card"
                        style={{
                            backgroundImage:
                                "url(assets/img/illustrations/corner-2.png)",
                        }}
                    ></div>
                   
                    <div className="card-body position-relative">
                        <div className="col-auto p-0">
                            <h6 style={{ display: "inline-block" }}>
                                Optin Rate{" "}
                                <span
                                    className="help-tooltip"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-html="true"
                                    title="Example: 20% means that 20% users opted to receive notifications from you and 80% actively rejected to receive notifications from you."
                                >
                                    <i className="fa fa-question-circle" />
                                </span>
                            </h6>
                            <a
                                style={{ float: "right" }}
                                href="/optin-funnel"
                                className="btn btn-sm btn-falcon-primary btn-info"
                                type="button"
                                data-index={0}
                                data-toggle="tooltip"
                                data-placement="top"

                                data-original-title="Optin Funnel"
                            >
                                <span className="fas fa-info" />
                            </a>
                        </div>
                        <div className="display-4 fs-4 mb-2 font-weight-normal text-sans-serif text-info optin-rate">
                            <div className="page-loader text-center  ">
                                <div
                                    className="spinner-border text-primary fs-0"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                        <a
                            className="font-weight-semi-bold fs--1 text-nowrap"
                            href="https://app.webpushr.com/optin-funnel"
                        >
                            More detail
                            <span
                                className="fas fa-angle-right ml-1"
                                data-fa-transform="down-1"
                            />
                        </a>
                    </div>
                </div>
                <div
                    className="card mb-3 overflow-hidden"
                    style={{ minWidth: "12rem" }}
                >
                    <div
                        className="bg-holder bg-card"
                        style={{
                            backgroundImage:
                                "url(assets/img/illustrations/corner-1.png)",
                        }}
                    ></div>
                    
                    <div className="card-body position-relative">
                        <h6>
                            Total Lifetime Users{" "}
                            <span
                                className="help-tooltip"
                                data-toggle="tooltip"
                                data-placement="top"
                                data-html="true"
                                title="All users that have ever opted to receive notifications. This number does not decrease even if users unsubscribe."
                            >
                                <i className="fa fa-question-circle" />
                            </span>
                        </h6>
                        <div className="display-4 fs-4 mb-2 font-weight-normal text-sans-serif text-warning total-subscribers">
                            <div className="page-loader text-center  ">
                                <div
                                    className="spinner-border text-primary fs-0"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <div className="card-deck">
                <div className="card mb-3 pb-3">
                    <div className="card-header">
                        <h6 className="mb-0">Active Browsers</h6>
                    </div>
                    <div className="card-body  browser-chart p-0">
                        <div className="mb-5 mt-3">
                            <div className="page-loader text-center  ">
                                <div
                                    className="spinner-border text-primary fs-0"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-3 pb-3">
                    <div className="card-header">
                        <h6 className="mb-0">Active Devices</h6>
                    </div>
                    <div className="card-body  device-chart p-0">
                        <div className="mb-5 mt-3">
                            <div className="page-loader text-center  ">
                                <div
                                    className="spinner-border text-primary fs-0"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-3 pb-3">
                    <div className="card-header">
                        <h6 className="mb-0">Active OS</h6>
                    </div>
                    <div className="card-body  os-chart p-0">
                        <div className="mb-5 mt-3">
                            <div className="page-loader text-center  ">
                                <div
                                    className="spinner-border text-primary fs-0"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <div className="card mb-3">
                <div className="card-header">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-6 col-sm-auto d-flex align-items-center pr-0">
                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">
                                Recent Subscribers
                            </h5>
                        </div>
                    </div>
                </div>
                <div className="card-body subscribers-log p-0">
                    <div className="mb-5 mt-3">
                        <div className="page-loader text-center  ">
                            <div
                                className="spinner-border text-primary fs-0"
                                role="status"
                            >
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer border-top">
                    <div className="row align-items-center">
                        <div className="col">
                            <p className="mb-0 fs--1 text-left">
                                <a
                                    className="font-weight-semi-bold"
                                    href="https://app.webpushr.com/subscribers"
                                >
                                    View All
                                    <span
                                        className="fas fa-angle-right ml-1"
                                        data-fa-transform="down-1"
                                    />
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* constent footer */}
            {/* <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Useful Links
                            </h5>
                            <button
                                className="close"
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="font-weight-light" aria-hidden="true">
                                    ×
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            For fastest help <strong>(preferred method)</strong>, ask
                            the <a href="https://forum.webpushr.com">Webpushr Forum</a>
                            <p />
                            <p>
                                <br />
                                E-mail (Sales):
                                <a href="mailto:sales@webpushr.com">sales@webpushr.com</a>
                                <br />
                                E-mail (Support):{" "}
                                <a href="mailto:support@webpushr.com">
                                    support@webpushr.com
                                </a>
                                .{" "}
                                <mark>
                                    Please send us your e-mail id if you decide to e-mail
                                    us. As you can imagine, we cannot locate your account
                                    unless we get your e-mail id.{" "}
                                </mark>
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary btn-sm"
                                type="button"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="modal fade"
                id="generalpopup"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="generaLModalLabel"
                aria-hidden="true"
            >
                <div
                    className="modal-dialog"
                    role="document"
                    style={{ width: "700px", maxWidth: "100%" }}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title" id="generaLModalLabel" />
                            <button
                                className="close"
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="font-weight-light" aria-hidden="true">
                                    ×
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div id="general-popup-content" />
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-primary btn-sm"
                                data-dismiss="modal"
                                aria-label="Close"
                                type="button"
                            />
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}
